import React from "react";
import { Button } from "reactstrap";

const PresetButton = (props) => (
  <Button
    {...props}
    onClick={() => {
      props.onClick({
        startDate: props["data-start"],
        endDate: props["data-end"],
      });
    }}
  >
    {props.children}
  </Button>
);

export default PresetButton;
